import { EItemActionType } from "../../interfaces/enum";
import { Item } from "../../interfaces/interfaces";
import { TItemAction } from "../reducers/itemReducer";

export const addTrendingItems = (items: Item[]): TItemAction => {
  return {
    type: EItemActionType.TRENDING_ITEMS,
    data: items,
  };
};

export const addRecommendedItems = (items: Item[]): TItemAction => {
  return {
    type: EItemActionType.RECOMMENDED_ITEMS,
    data: items,
  };
};

export const addMovies = (items: Item[]): TItemAction => {
  return {
    type: EItemActionType.MOVIES,
    data: items,
  };
};

export const addSeries = (items: Item[]): TItemAction => {
  return {
    type: EItemActionType.SERIES,
    data: items,
  };
};

export const addBookmarked = (items: Item[] | Item): TItemAction => {
  return {
    type: EItemActionType.BOOKMARKED,
    data: items,
  };
};

export const removeBookmarked = (item: Item): TItemAction => {
  return {
    type: EItemActionType.REMOVE_BOOKMARK,
    data: item,
  };
};

export const setLoading = (value: boolean): TItemAction => {
  return {
    type: EItemActionType.LOADING,
    data: value,
  };
};
